import { useEffect, useState } from "react";
import { Mail, Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Card } from "./ClienteCharts";

// Il cliente attiva/disattiva il riepilogo via email (settimanale il lunedì, mensile il 1° del mese)
export function RiepilogoCard({ src }) {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { src.riepilogo().then(setR).catch(() => setR({ email: "", settimanale: false, mensile: false, allarmi: true })); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const err = (e) => toast.error(e.response?.data?.detail || "Operazione non riuscita");
  const salva = async (next) => {
    setBusy("salva");
    try { await src.salvaRiepilogo(next); setR(next); toast.success("Preferenze salvate"); } catch (e) { err(e); }
    setBusy("");
  };
  const prova = async () => { setBusy("prova"); try { await src.provaRiepilogo(); toast.success("Email di prova inviata"); } catch (e) { err(e); } setBusy(""); };
  if (!r) return null;
  const T = ({ k, l, sub }) => (
    <label className="flex items-center justify-between gap-3 rounded-2xl bg-slate-50 p-3">
      <span><b className="block text-sm text-slate-800">{l}</b><span className="text-xs text-slate-500">{sub}</span></span>
      <Switch checked={r[k]} onCheckedChange={(v) => setR({ ...r, [k]: v })} data-testid={`cliente-riepilogo-${k}`} />
    </label>
  );
  return (
    <Card title="Email dal tuo impianto" testid="cliente-riepilogo">
      <p className="mb-3 text-sm text-slate-500">Ricevi un'email semplice con produzione, uso della batteria, consumi e CO₂ evitata, e un avviso se l'impianto si ferma.</p>
      <div className="relative mb-2.5">
        <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <input type="email" value={r.email} onChange={(e) => setR({ ...r, email: e.target.value })} placeholder="La tua email"
          className="h-11 w-full rounded-2xl bg-slate-100 pl-9 pr-3 text-sm outline-none focus:ring-2 focus:ring-sky-200" data-testid="cliente-riepilogo-email" />
      </div>
      <div className="space-y-2">
        <T k="settimanale" l="Ogni settimana" sub="il lunedì mattina" />
        <T k="mensile" l="Ogni mese" sub="il 1° del mese, al mattino" />
        <T k="allarmi" l="Avvisi se l'impianto si ferma" sub="solo se resta fermo almeno 2 ore o non comunica da oltre 24 ore" />
      </div>
      {r.allarmi && !r.email && <p className="mt-2 text-xs text-slate-400" data-testid="cliente-riepilogo-allarmi-nota">Senza un indirizzo qui, usiamo l'email registrata sul tuo impianto.</p>}
      <div className="mt-3 flex gap-2">
        <button type="button" onClick={() => salva(r)} disabled={!!busy} data-testid="cliente-riepilogo-salva"
          className="flex-1 rounded-2xl bg-sky-500 py-2.5 text-sm font-bold text-white disabled:opacity-50">{busy === "salva" ? <Loader2 className="mx-auto h-4 w-4 animate-spin" /> : "Salva"}</button>
        <button type="button" onClick={prova} disabled={!!busy || !r.email} data-testid="cliente-riepilogo-prova"
          className="inline-flex items-center gap-1.5 rounded-2xl bg-slate-100 px-3 text-xs font-bold text-slate-600 disabled:opacity-50">{busy === "prova" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}Invia una prova</button>
      </div>
    </Card>
  );
}
